import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '~/components/core/Atomic/FormControl';
import FormControlLabel from '~/components/core/Atomic/FormControlLabel';
import Typography from '~/components/core/Atomic/Typography';
import Radio from '~/components/ui/atoms/Radio';
import cn from '~/Utils/cn';

import { useStyles } from '../../assets/styles';

const POSITIONS = {
  START: 'start',
  END: 'end',
};

const RadioWithButtonWrapper = ({
  className,
  icon,
  text,
  name,
  value,
  disabled,
  wrapperOverrideStyle = {},
  checked,
  iconLocation = POSITIONS.START,
  onChange,
}) => {
  const { classes } = useStyles();

  const marginFromSideProp = iconLocation === POSITIONS.START ? 'marginRight' : 'marginLeft';
  const iconWrapper = <span style={{ [marginFromSideProp]: '10px' }}>{icon}</span>;

  const label = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {icon && iconLocation === POSITIONS.START && iconWrapper}
      <Typography display="block" variant="body1">
        {text}
      </Typography>
      {icon && iconLocation === POSITIONS.END && iconWrapper}
    </div>
  );

  return (
    <div
      className={cn(classes.radioOrCheckboxWithIcon, className, { disabled })}
      style={wrapperOverrideStyle}
      onClick={() => !disabled && onChange(value)}
    >
      <FormControl>
        <FormControlLabel
          value=""
          control={
            <Radio
              name={name}
              checked={checked}
              onChange={() => !disabled && onChange(value)}
              disabled={disabled}
              size="xs"
            />
          }
          label={label}
          labelPlacement="end"
        />
      </FormControl>
    </div>
  );
};

RadioWithButtonWrapper.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  text: PropTypes.string.isRequired,
  /** Shared by the options of one choice, so they form one radio group: one Tab stop, arrow keys inside it. */
  name: PropTypes.string.isRequired,
  value: PropTypes.node,
  disabled: PropTypes.bool,
  wrapperOverrideStyle: PropTypes.object,
  checked: PropTypes.bool,
  iconLocation: PropTypes.oneOf(Object.values(POSITIONS)),
  onChange: PropTypes.func.isRequired,
};

RadioWithButtonWrapper.POSITIONS = POSITIONS;

export default RadioWithButtonWrapper;
